import { Message } from "element-ui";

/**
 * ai发送消息
 * @param query
 */
export async function sendMessage(query, ctrl) {
  try {
    const response = await fetch('/api/v1/leadsqa/qa_interface', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(query),
      signal: ctrl.signal,
    });
    if (!response.ok) {
      throw new Error('当前网络异常，请稍后再试！')
    }
    return response;
  } catch (e) {
    throw new Error('当前网络异常，请稍后再试！')
  }

}

export class EmbedRequestError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "EmbedRequestError";
    this.status = status;
  }
}

/**
 * 嵌入页 AI 请求。Token 由 postMessage 获取并随 JSON 请求体发送。
 * 不携带站点 Cookie，避免嵌入用户与主站登录态混用。
 */
export async function sendEmbedMessage(query, signal) {
  const response = await fetch("/api/v1/leadsqa/qa_interface_dxe", {
    method: "POST",
    credentials: "omit",
    cache: "no-store",
    headers: {
      Accept: "application/json, text/event-stream",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(query),
    signal,
  });

  if (!response.ok) {
    throw new EmbedRequestError("AI 服务请求失败", response.status);
  }

  return response;
}

/**
 * 获取热门问题
 * @param query
 */
export async function getHotQuestion(query) {
  try {
    const hotQuestion = await fetch('/api/v1/leadsqa/hot_question', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(query),
    });
    const hotQuestionData = await hotQuestion.json();
    return hotQuestionData;
  }catch (e) {
    // 保持原有静默失败行为
  }

}

/**
 * 获取相似问题
 * @param query
 */
export async function getMoreQuestions(query) {
  try {
    const moreQuestions = await fetch('/api/v1/leadsqa/get_simi_query', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(query),
    });
    const moreQuestionsData = await moreQuestions.json();
    return moreQuestionsData;
  } catch (e) {
    // 保持原有静默失败行为
  }
}

/**
 * ai答案认同/不认同
 * @param query
 */
export async function saveQueryStatus(query) {
  try {
    const qaStatus = await fetch('/api/v1/leadsqa/qa_status', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(query),
    });
    const qaStatusData = await qaStatus.json();
    return qaStatusData;
  } catch (error) {
    Message({
      message: '当前网络异常，请稍后再试！',
      type: "warning",
      duration: 5 * 1000,
    })
  }
}

/**
 * 导出图片中的表格
 * @param query
 */
export async function getTableExport(query) {
  try {
    const tableExport = await fetch('/api/v1/leadsqa/get_table_export', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(query),
    });
    const tableExportData = await tableExport.json();
    return tableExportData;
  }catch (e) {
    // 保持原有静默失败行为
  }

}
